import React from "react";
import "./Preview.scss";
import newBrand from "../../assets/new.png";
import comingSoonBrand from "../../assets/coming-soon.png";
import topBrand from "../../assets/top.png";
import qrModalIcon from "../../assets/qr-icon.png";
import { useConfigProvider } from "../../contexts/ConfigProvider";
import { CurrencyData, Game, Jackpot, configVersion } from "../../interfaces/interfaces";
import { useGameParamsStore } from "../../store/gameParams";
import { useGameLangStore } from "../../store/gameLanguage";
import { getLocaleByCurrency } from "../../utils/getLocaleByCurrency"
import Modal from "../Modal/Modal";

type Props = {
  game: Game;
  demo: boolean;
  token: string;
  currency: string;
  gameUrl: string;
  jackpot: Jackpot | null;
  configUrl: string;
  currencies: CurrencyData | undefined;
  configurationVersion: configVersion | undefined;
};

const Preview = ({ game, token, currency, demo, gameUrl, jackpot, configUrl, currencies, configurationVersion }: Props) => {
  const { features } = useConfigProvider();
  const lang = useGameLangStore((state) => state.lang);
  const { params } = useGameParamsStore((state) => state);
  const [previewLoaded, setPreviewLoaded] = React.useState<boolean>(false);
  const locale = getLocaleByCurrency(currency);
  const decimals = currencies ? currencies[`${currency.toLowerCase()}`]?.decimals ?? 0 : 0;
  
  const [isShowModal, setShowModal] = React.useState<boolean>(false);

  const openGame = (e: React.MouseEvent<HTMLElement>) => {
    const device = params.isMobile ? "mobile" : "desktop";
    e.preventDefault();
    const url = `${gameUrl}?game=${game.name}&device=${device}&token=${token}&demo=${+demo}&lang=${lang}`;
    params.newWindow ? window.open(url, '_blank') : window.location.href = url;
  }

  const loadPreviewImage = () => {
    const img = new Image();
    img.src = `${configUrl}/configurations/images/showroom/previews/preview-${game.name}.svg?version=${configurationVersion?.version}`;
    
    img.onload = () => {
      setPreviewLoaded(true);
    };
    img.onerror = () => {
      setPreviewLoaded(false);
    };
  };

  loadPreviewImage();

  const obtainJackpotValue = () => {

    let jackpotValue = `${Intl.NumberFormat(`${locale}`, { style: 'currency', currency: currency, maximumFractionDigits: decimals}).format(decimals ? (jackpot?.value ?? 0)/100 : Math.trunc((jackpot?.value ?? 0)/100 ))}`;
    if (currency === "CRC"){
      jackpotValue = jackpotValue.replace(/\s/g, '.')
    }
    return jackpotValue;
  }

  return (
    <div className="preview-container">
      <div className="preview">
        {game.isNew && (
          <img
            src={newBrand}
            className="preview-isTagged"
            alt="zitro digital"
          />
        )}
        {game.isComingSoon && (
          <img
            src={comingSoonBrand}
            className="preview-isTagged"
            alt="zitro digital"
          />
        )}
        {game.isTop && (
          <img
            src={topBrand}
            className="preview-isTagged"
            alt="zitro digital"
          />
        )}
        {previewLoaded ? (
          <img
            src={`${configUrl}/configurations/images/showroom/previews/preview-${game.name}.svg?version=${configurationVersion?.version}`}
            className="preview-image"
            alt={game.name}
          />
        ) : (
          <div className="preview-default-image">
            <p className="preview-default-text">{game.description}</p>
          </div>
        )}

        <div className="preview-selector">
          <div className="preview-header">
            <div className="title">{game.description}</div>
            {game.isPlayable === undefined || game.isPlayable ? (
              <button className="play-game-btn" onClick={(game.isPlayable === undefined || game.isPlayable) ? openGame : undefined}>
                <span className="material-symbols-outlined">play_arrow</span>
              </button>
            ):
            (
              <div className="game-blocked">
                <span className="material-symbols-outlined">block</span>
              </div>
            )}
          </div>
          {(features.withQRCode && (game.isPlayable === undefined || game.isPlayable)) && (
            <div className="qr-container">
              <button className="preview-qr-button" onClick={() => setShowModal(true)}>
                <img src={qrModalIcon} className="preview-qr-icon" alt="Abrir QR" />
              </button>
            </div>
          )}
        </div>
        
      </div>
      {features.withJackpots && 
        ((jackpot) ? <div className="preview-jackpot">{obtainJackpotValue()}</div> : <div></div>)
      }
      <Modal
        show={isShowModal}
        onClose={()=> {setShowModal(false)}}
        game={game}
        token={token}
        gameUrl={gameUrl}
      />
    </div>
  );
};

export default React.memo(Preview);
